export default "__VITE_PUBLIC_ASSET__014ed42a__"